export enum Country {
  CZ = 'CZ',
  SK = 'SK',
}

export const CountryLabels: Record<keyof typeof Country, string> = {
  CZ: 'Česká Republika',
  SK: 'Slovensko',
};
